import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus, ArrowRight } from "lucide-react";

interface AddServicesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAddServices: () => void;
  onContinueWithoutServices: () => void;
}

export const AddServicesModal: React.FC<AddServicesModalProps> = ({
  open,
  onOpenChange,
  onAddServices,
  onContinueWithoutServices
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md w-[calc(100%-2rem)] sm:w-full">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Plus className="w-5 h-5 text-primary" />
            Ajouter des prestations ?
          </DialogTitle>
          <DialogDescription className="text-left">
            Souhaitez-vous ajouter des prestations complémentaires à votre demande 
            (Traiteur, Décoration, Location évènementiel, Animation, etc.) ?
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col space-y-3 mt-6">
          <Button
            onClick={onAddServices}
            className="flex items-center justify-center gap-2 bg-primary hover:bg-primary-hover w-full"
          >
            <Plus className="w-4 h-4" />
            Ajouter des prestations
          </Button>
          <Button
            variant="outline"
            onClick={onContinueWithoutServices}
            className="flex items-center justify-center gap-2 w-full"
          >
            <ArrowRight className="w-4 h-4" />
            Continuer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};